import script from "./TopScoringList.vue?vue&type=script&lang=ts&setup=true"
export * from "./TopScoringList.vue?vue&type=script&lang=ts&setup=true"

import "./TopScoringList.vue?vue&type=style&index=0&id=245766a6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-245766a6"]])

export default __exports__